import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Browse all feature flags in the system. Use the <strong>search bar</strong> to find specific flags by name." id="browse_all_feature_flags_in_the_system_u.cd989d26" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Viewing Feature Flags" id="viewing_feature_flags.f461be9f" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Create</strong> to add a new feature flag. Provide a name and configure its initial state (enabled or disabled)." id="click_create_to_add_a_new_feature_flag_p.514a3bb5" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating a Flag" id="creating_a_flag.5e11895e" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="View the history of changes to a feature flag, including when it was <strong>created</strong>, <strong>modified</strong>, or <strong>deleted</strong>." id="view_the_history_of_changes_to_a_feature.59630a3a" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Activity History" id="activity_history.9cf4a21a" />
        }
    ],
    title: <FormattedMessage defaultMessage="Feature Flags" id="feature_flags.b1263a5a" />
};
